import { useNavigate } from "react-router-dom";
import { create } from "@/apis/subscription";
import Router from "@/constants/router";
import { useModal } from "mui-modal-provider";
import { Alert } from "@/organism/Alert";
import { SubscriptionProductCreateRequestDto } from "@/dto/SubscriptionDto";
import { useState } from "react";
import { enqueueSnackbar } from "notistack";

/**
 * 구독 상품 생성 Hook
 *
 * @returns {object} 구독 상품 생성 관련 메서드
 *
 * @author Max <sud665@ymjlab.com>
 * @version 1.0
 * @since 2025-05-08
 */
export default function useCreate() {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const { showModal } = useModal();

  /**
   * 구독 상품 생성 처리
   *
   * @param data 구독 상품 생성 요청 DTO
   */
  const handleSubmit = async (data: SubscriptionProductCreateRequestDto) => {
    try {
      setIsLoading(true);




      const result = await create(data);
      if (result.success) {
        enqueueSnackbar("구독 상품 생성이 완료되었습니다.", {
          variant: "success",
        });
        navigate(Router.Subscription);
      } else {
        showModal(Alert, {
          title: "오류",
          content: result.message,
          onClose: () => {},
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  return {
    handleSubmit,
    isLoading,
  };
}
